<template>
    <div class="configuration-preview-container">
        <v-card class="preview-card-container">
            <div class="preview-details-container">
                <h3>Preview</h3>
                <p class="details-title-label">Workspace</p>
                <p class="details-title">{{ workspaceLabel }}</p>
                <p class="details-title-label mt-5">Mandatory-buildings</p>
                <div class="details-list-container">
                    <div v-for="(building, index) in selectedBuildings" :key="index">
                        <p class="building-title">{{ getBuildingLabel(building) }}</p>
                    </div>
                </div>
                <div class="btn-container">
                    <v-btn
                        @click="cancel"
                        class="previousBtn"
                    >
                        Cancel
                    </v-btn>
                </div>
                <div class="preview-input-container">
                    <p class="details-title-label">Percentages</p>
                    <div>
                        <input class="preview-input" id="percentage1" type="number" @input="inputHandler"/>
                        <input class="preview-input" id="percentage2" type="number" @input="inputHandler" />
                    </div>
                    <div>
                        <input class="preview-input" id="percentage3" type="number" @input="inputHandler" />
                        <input class="preview-input" id="percentage4" type="number" @input="inputHandler" />
                    </div>
                </div>
            </div>
            <div class="preview-map-container">
                <h3 class="map-title">Map</h3>
                <div class="map-container">
                    <workspace-map
                        ref="workspaceMap"
                        :polygon="getSelectedPolygon"
                        :workspace="getSelectedWorkspace"
                        :draw-polygon="false"
                        :view-all-workspaces="false"
                        :is-npv="true"
                        :is-npv-preview="true"
                        :buildings="selectedBuildings"
                    />
                </div>
            </div>
        </v-card>
    </div>
</template>
  
<script>
    import { mapActions } from "vuex";
    import WorkspaceMap from '@/components/ProjectManagement/Workspaces/WorkspaceMap'
    import { configurationsMixin } from "@/mixins/npv/configurationsMixin";
    export default {
        name: "ConfigurationPreview",
        components: {
            WorkspaceMap
        },
        mixins: [configurationsMixin],
        data() {
            return {
                percentage1: null,
                percentage2: null,
                percentage3: null,
                percentage4: null
            }
        },
        computed: {
            workspaceLabel(){
                const label = this.$store.getters.getWorkspace ? this.$store.getters.getWorkspace.wp_label : ''
                return label
            },
            getSelectedWorkspace(){
                return this.$store.getters.getWorkspace
            },
            getSelectedPolygon(){
                let polygon;
                if(!this.$store.getters.getWorkspace && this.$store.getters.getWorkspaceGeometry){
                    polygon = this.convertToGeoJSON(this.$store.getters.getWorkspaceGeometry);
                }
                return polygon;
            },
            selectedBuildings() {
                return this.$store.getters.getSelectedBuildings;
            },
        },
        methods: {
            ...mapActions(["clearWorkspace", "clearWorkspaceGeometry", "clearBuildings", "clearSimulationConfiguration", "editPercentage", "clearPercentage"]),
            getBuildingLabel(building) {
                return building.bd_label ? building.bd_label : `id:${building.bd_id}`;
            },
            inputHandler(e){
                this[e.target.id] = e.target.value;
                if(e.target.id === 'percentage1'){
                    this.editPercentage({index:0, value: e.target.value})
                }else if(e.target.id === 'percentage2'){
                    this.editPercentage({index:1, value: e.target.value})
                }else if(e.target.id === 'percentage3'){
                    this.editPercentage({index:2, value: e.target.value})
                }else{
                    this.editPercentage({index:3, value: e.target.value})
                }
            },
            cancel(){
                this.clearWorkspace();
                this.clearWorkspaceGeometry();
                this.clearBuildings();
                this.clearSimulationConfiguration();
                this.clearPercentage();
                this.$emit('cancel');
            },
        }
    };
</script>
<style scoped>
.configuration-preview-container{
    width: 100%;
    height: calc(100% - 110px);
    display: flex;
}
.preview-card-container{
    width: 100%;
    height: 100%;
    margin-top: 15px;
    padding: 0px 40px 40px 28px;
    display: flex;
}
.preview-details-container{
    width: 22%;
    padding-top: 20px;
    text-align: start;
    font-size: 12px;
    position: relative;
}
.preview-details-container h3{
    margin-bottom: 50px;
    color: #4fa2b7;
    font-size: 1.17em;
}
.details-title-label{
    margin-bottom: 5px;
    padding-left: 5px;
    color: #4FA2B7;
}
.details-title{
    width: 170px;
    min-height: 28px;
    padding: 5px;
    background-color: #F0F0EF ;
    border-radius: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #767676;
}
.details-list-container{
    width: 170px;
    border-radius: 8px;
    min-height: 28px;
    max-height: calc(100% - 400px);
    background-color: #F0F0EF;
    padding: 10px 5px;
    overflow-y: auto;
    color: #767676;
}
.building-title{
    padding-left: 5px;
    margin-bottom: 10px;
    border-bottom: 1px solid #DBDBE0;
}
.btn-container{
    position: absolute;
    bottom: 0px;
}
.previousBtn {
  border-radius: 8px;
  border: 1px solid #67a0b4;
  background-color: #fff !important;
  color: #67a0b4;
  margin-right: 16px;
  box-shadow: none !important;
  height: 30px !important;
  font-size: 12px !important;
}
.preview-map-container{
    width: 78%;
}
.preview-input-container{
    margin-top: 16px;
    width: 100%;
    display: flex;
    flex-direction: column;
}
.preview-input{
    width: 50px;
    background-color: #F0F0EF;
    border-radius: 8px;
    margin-bottom: 10px;
    margin-right: 10px;
    padding: 5px;
}
.map-title{
    padding-top: 20px;
    text-align: left;
    color: #4fa2b7;
    padding-bottom: 25px;
}
.map-container{
    width: 100%;
    height: calc(100% - 70px);
}
</style>
  


// WEBPACK FOOTER //
// src/components/Npv/Configuration/views/ConfigurationPreview.vue